"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.enableBodyScroll = exports.disableBodyScroll = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _themeContext = _interopRequireDefault(require("../context/theme-context"));
var _themeConsumer = _interopRequireDefault(require("./theme-consumer"));
var _theme = _interopRequireDefault(require("../themes/theme.css"));
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_themeContext["default"].Provider, {
    value: _theme["default"]
  }, /*#__PURE__*/_react["default"].createElement(_themeConsumer["default"], null, children));
};
var disableBodyScroll = function disableBodyScroll() {
  document.body.classList.add(_theme["default"].modalOpen);
};
exports.disableBodyScroll = disableBodyScroll;
var enableBodyScroll = function enableBodyScroll() {
  document.body.classList.remove(_theme["default"].modalOpen);
};
exports.enableBodyScroll = enableBodyScroll;
var _default = ThemeProvider;
exports["default"] = _default;